import useComposerEvents from '~/hooks/home/appRouter/useComposerEvents';

export default function AppRouterComposerEvents() {
  useComposerEvents();

  return null;
}
